import { h, Fragment, Component, createRef } from "preact";
import { useState, useEffect, useContext, useCallback } from "preact/hooks";

import { makeStyles } from "@mui/styles";
import { AppBar, Alert, Badge, Box, Button, IconButton, Menu, MenuItem, Popover, Stack, Typography, Toolbar, Tooltip } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import Logo from "./Logo";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EmailIcon from "@mui/icons-material/Email";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { SupportIconeBadge } from "../SupportIconeBadge";
import { SessionContext } from "../../SessionContext";
import PopupState from "material-ui-popup-state";
import HoverMenu from "material-ui-popup-state/HoverMenu";

import { usePopupState, bindHover, bindPopper, bindMenu } from "material-ui-popup-state/hooks";

export class HeaderConnecte extends Component {

  constructor(props) {
    super(props);
    this.state = {};

    this.inputRef = createRef();

  }

  handleChangeState = (st) => {
    console.log("handle change state hd connecte", st);

    this.setState({ ...this.state, ...st }, () => {
      // console.log("state updated !!");

      //console.log(this.inputRef.current.getBoundingClientRect())
      this.props.setState({ headerHeight: this.inputRef.current.getBoundingClientRect().height })
    })
  }

  getRealHeight = () => {
    return this.inputRef.current.getBoundingClientRect().height
  }

  makepublic() {
    app.refPopUp.current.handleChangeState(
      {
        opened: true,
        type: "001",
        params: {}
      }
    )
  }

  render() {

    //console.log("render HeaderConnecte", this.state, this.props)
    console.log(this.state.guidelines);
    return (

      <AppBar position="fixed" style="background-color: white; " ref={this.inputRef} >
        <PrimarySearchAppBar />
        {this.state.guidelines && <Alert
          icon={this.state.guidelines.icon ? this.state.guidelines.icon : false}
          action={
            <Stack spacing={2} justifyContent="center" style="height: 100%">
              {
                this.state.guidelines.actions ?
                  this.state.guidelines.actions.map((a) => {
                    return a
                  })
                  : null
              }
              {this.state.guidelines.message_proxied && this.state.guidelines.message_proxied.length > 0 && <div style="margin-top: 10px" >
                {
                  this.state.guidelines.message_proxied.map((pm) => {
                    const k = Object.keys(pm);

                    return k.map((kk) => pm[kk].filter((l) => (l.action !== undefined && l.action.p !== true)).length > 0 ? <div>
                      <Typography variant={"h5"}>Pour {kk}</Typography>
                      {pm[kk].filter((l) => (l.action !== undefined && l.action.p !== true)).map((l) => {
                        console.log(l);
                        return l.action ? <div style="margin-top: 10px;">
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => {
                              window.location.href = l.action.u;
                            }}
                          >
                            {l.action.l}
                          </Button>
                        </div> : null
                      })}
                    </div> : null)
                  })
                }
              </div>
              }

            </Stack>
          }
          severity={this.state.guidelines.severity ? this.state.guidelines.severity : "warning"}
          style="margin: 0px 10px 10px; box-shadow: 0px 0px 5px 0px red; max-height: 150px;"

        >

          {this.state.guidelines.message}
          {this.state.guidelines.message_proxied && this.state.guidelines.message_proxied.length > 0 && <div style="margin-top: 10px" >
            {
              this.state.guidelines.message_proxied.map((pm) => {
                const k = Object.keys(pm);
                // console.log("aqw", k)
                return k.map((kk) => pm[kk].length > 0 ? <div>
                  <Typography variant={"h5"}>Pour {kk}</Typography>
                  {pm[kk].map((l, i) => {
                    //console.log("aqw2", l)
                    return <Typography>{i + 1} {l.label ? l.label : l}</Typography>
                  })}
                </div> : null)
              })
            }
          </div>
          }
        </Alert>}
        {/* {this.renderMobileMenu} */}
      </AppBar >


    );
  }
}

const PrimarySearchAppBar = (props) => {
  const useStyles = makeStyles((theme) => ({
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },

    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    typography: {
      padding: theme.spacing(2),
    },
  }));
  const classes = useStyles();

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogout = (event) => {
    window.location.href = "/login";
  };
  const menuId = "menu-desktop";

  const mobileMenuId = "menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem
        onClick={() => {
          window.location.href = "/dashboard";
        }}
      >
        <p>Mon profil</p>
      </MenuItem>
      <MenuItem
        onClick={() => {
          window.location.href = "/unotifs";
        }}
      >
        <p>Notifications</p>
      </MenuItem>

      <MenuItem onClick={handleLogout}>
        <p>Se déconnecter</p>
      </MenuItem>
    </Menu>
  );
  const [height, setHeight] = useState(0);
  const measuredRef = useCallback(node => {
    if (node !== null) {
      console.log("got a height !!", node, node.getBoundingClientRect())
      setHeight(node.getBoundingClientRect().height);
    }
  }, []);

  const [sessionState, setSessionState] = useContext(SessionContext);
  //console.log(props, props.divRef)

  //console.log("render primary bar", sessionState)
  if (sessionState.name === undefined) {
    return;
  }

  ///////////////
  const [anchorEl, setAnchorEl] = useState(null);
  const [mailStatus, setMailStatus] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const goToV = (event) => {
    window.location.href = "/dashboardv";
  };
  const goToA = (event) => {
    window.location.href = "/dashboarda";
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  //////////////////////:
  const popupState = usePopupState({
    variant: "popper",
    popupId: "demoPopper",
  });

  if (window.location.href.includes("/devenir-ambassadeur/1") ||
    window.location.href.includes("/devenir-vendeur/1") ||
    window.location.href.includes("/devenir-ambassadeur/2") ||
    window.location.href.includes("/devenir-vendeur/2") ||
    window.location.href.includes("/devenir-ambassadeur/3") ||
    window.location.href.includes("/devenir-vendeur/3")) {
    return (<Toolbar >
      <IconButton href="/" >

        <Logo color="primary" />
      </IconButton>
      <div className={classes.grow} />

    </Toolbar >)
  }

  return (

    <Toolbar style="display: flex; justify-content: space-between; align-items: center">
      {/* <div style="display: flex; justify-content: space-between; align-items: center" > */}
      <IconButton onClick={() => { window.location.href = "https://www.bkeys.com/" }}>
        <Logo color="primary" />
      </IconButton>
      {window.location.href.startsWith("https://members.demo.bkeys.com") && <div><Typography variant={"h5"}>SITE DEMO*</Typography></div>}
      {/* <div className={classes.grow} /> */}
      <div className={classes.sectionDesktop}>
        <PopupState variant="popover" popupId="demoMenu">
          {(popupState) => (
            <Fragment>
              <IconButton style="border-radius: 10px;" {...bindHover(popupState)} onClick={() => window.location.href = "/dashboard"}>
                <Tooltip title="Aller sur votre écran d'accueil" placement="bottom" arrow><Typography variant="h5" className={classes.title}>
                  {sessionState.name}
                </Typography>
                </Tooltip>
              </IconButton>

              {false && <HoverMenu
                {...bindMenu(popupState)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                getContentAnchorEl={null}
              //  transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {/* <MenuItem onClick={goToUser}>Voir mon profil</MenuItem> */}

                {!sessionState.role_a && <MenuItem onClick={goToA}>Devenir ambassadeur</MenuItem>}
                {sessionState.role_a && <MenuItem onClick={goToA}>Espace ambassadeur</MenuItem>}
                {!sessionState.role_du && <MenuItem onClick={goToV}>Devenir vendeur</MenuItem>}
                {sessionState.role_du && <MenuItem onClick={goToV}>Espace vendeur</MenuItem>}

              </HoverMenu>}
            </Fragment>
          )}
        </PopupState>

        <Tooltip title="Support" placement="bottom" arrow>
          <IconButton
            edge="end"
            aria-label="mailbox"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={() => {
              window.location.href = "/support";
            }}
            color="inherit"
            style={{ marginRight: "10px" }}
            fontSize="large"
            aria-describedby={id}
          >
            <SupportIconeBadge>
              <EmailIcon style={{ color: "black" }} />
            </SupportIconeBadge>
          </IconButton>
        </Tooltip>
        <Tooltip title="Vous déconnecter du site" placement="bottom" arrow>
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleLogout}
            color="inherit"
            style="marging-right: 10px;"
            fontSize="large"
          >
            <ExitToAppIcon style={{ color: "black" }} />
          </IconButton>
        </Tooltip>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Typography className={classes.typography}>Emails</Typography>
          <Typography className={classes.typography}>{mailStatus}</Typography>


        </Popover>
      </div>
      <div className={classes.sectionMobile}>
        <IconButton
          edge="end"
          aria-label="user dashboard"
          aria-controls={menuId}
          aria-haspopup="true"
          href="/dashboard"
          color="inherit"
          style="marging-right: 10px;"
          fontSize="large"
        >
          <DashboardIcon style={{ color: "black" }} />
        </IconButton>
        <IconButton aria-label="show more" aria-controls={mobileMenuId} aria-haspopup="true" onClick={handleMobileMenuOpen} color="inherit">
          <MenuIcon color="primary" />
        </IconButton>
      </div>
      {renderMobileMenu}
      {/* </div> */}

    </Toolbar >


  );
}

